import { render, staticRenderFns } from "./rptsupplierreceiving.vue?vue&type=template&id=4ac72028"
import script from "./rptsupplierreceiving.vue?vue&type=script&lang=js"
export * from "./rptsupplierreceiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports